import React from 'react'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogTitle from '@mui/material/DialogTitle'
import Slide from '@mui/material/Slide'
import Button from '@mui/material/Button'
import { useSelector } from 'react-redux'
import { Typography } from '@mui/material'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />
})

const ItemAdded = ({ course, handleClose }) => {
  const styles = {
    actions: {
      display: 'flex',
      justifyContent: 'center'
    },
    button: {
      backgroundColor: '#C80F2D',
      color: 'white'
    }
  }
  const volumeDiscountCount = useSelector(
    (state) => state.cart.volumeDiscountCount
  )
const volumeDiscountMessage = () => {
  return ''
  // // Toggle multicamp discount
  // if (volumeDiscountCount === 0) {
  //   return ""
  // }

  // const maxDiscount = 20;
  // const discountStep = 5;
  // const discount = Math.min(volumeDiscountCount * discountStep, maxDiscount);

  // if (discount < maxDiscount) {
  //   return `Add another workshop to save ${discount}% off.`;
  // }

  // return "You're saving 20% off!";
};
  return (
    <div>
      <Dialog
        open
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby='alert-dialog-slide-description'
      >
        <DialogTitle>
          Added {course.metadata.courseName} to the cart!
        </DialogTitle>
        <Typography align='center'>{volumeDiscountMessage()}</Typography>
        <DialogActions style={styles.actions}>
          <Button
            onClick={() => {
              handleClose()
            }}
            style={styles.button}
          >
            Continue
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default ItemAdded
